import React, { useEffect } from 'react';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import {
  PageContainer,
  MainContent,
  Container,
  ContentSection,
  HeaderSection,
  Title,
  Subtitle,
  ContentWrapper,
  Section,
  SectionTitle,
  SectionContent,
  Paragraph,
  List,
  ListItem,
  ContactInfo,
} from './Privacy.styled';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fadeIn = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.1, 0.25, 1] },
    },
  };

  const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <PageContainer>
      <Header />

      <MainContent>
        <ContentSection>
          <Container>
            <ContentWrapper
              initial="hidden"
              animate="visible"
              variants={staggerContainer}
            >
              <HeaderSection>
                <Title variants={fadeIn}>Privacy Policy</Title>
                <Subtitle variants={fadeIn}>
                  At Swan Pipe Support Pvt. Ltd., we value your privacy. This
                  Privacy Policy explains how we collect, use, and protect your
                  personal information.
                </Subtitle>
              </HeaderSection>

              <Section variants={fadeIn}>
                <SectionTitle data-number="1">
                  Information We Collect
                </SectionTitle>
                <SectionContent>
                  <Paragraph>
                    <strong>Personal Information:</strong> Name, phone number,
                    email address, shipping/billing address (when you make an
                    inquiry or place an order).
                  </Paragraph>
                  <Paragraph>
                    <strong>Non-Personal Information:</strong> Browser type, IP
                    address, pages visited on our website, and cookies for site
                    analytics.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="2">
                  How We Use Your Information
                </SectionTitle>
                <SectionContent>
                  <List>
                    <ListItem>To process orders and deliver products.</ListItem>
                    <ListItem>
                      To respond to your inquiries and provide customer support.
                    </ListItem>
                    <ListItem>To improve our website and services.</ListItem>
                    <ListItem>
                      To send you updates, promotions, or product information
                      (only if you have opted in).
                    </ListItem>
                  </List>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="3">Data Protection</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    We take reasonable steps to secure your personal data from
                    unauthorized access or disclosure.
                  </Paragraph>
                  <Paragraph>
                    We do not sell, rent, or trade your personal information to
                    third parties.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="4">Cookies</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    Our website may use cookies to enhance your browsing
                    experience.
                  </Paragraph>
                  <Paragraph>
                    You can choose to disable cookies in your browser settings,
                    but some site features may not function properly.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="5">
                  Third-Party Services
                </SectionTitle>
                <SectionContent>
                  <Paragraph>
                    We may use trusted third-party services (e.g., analytics,
                    payment gateways) that process your data under strict
                    confidentiality agreements.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="6">Your Rights</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    You can request access to, correction of, or deletion of
                    your personal data by contacting us.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="7">Policy Changes</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    We may update this Privacy Policy from time to time. Changes
                    will be posted on this page with the updated date.
                  </Paragraph>
                </SectionContent>
              </Section>

              <Section variants={fadeIn}>
                <SectionTitle data-number="8">Contact Us</SectionTitle>
                <SectionContent>
                  <Paragraph>
                    For any questions about these Terms & Conditions or Privacy
                    Policy, please contact:
                  </Paragraph>
                  <ContactInfo>
                    <strong>Swan Pipe Support Pvt. Ltd.</strong>
                    <br />
                    Madurai, Tamil Nadu, India
                  </ContactInfo>
                </SectionContent>
              </Section>
            </ContentWrapper>
          </Container>
        </ContentSection>
      </MainContent>

      <Footer />
    </PageContainer>
  );
};

export default Privacy;
